import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSamsungpayComponent } from './simple-icons-samsungpay.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSamsungpayComponent ],
    exports:      [ SimpleIconsSamsungpayComponent ],
    bootstrap:    []
})
export class SimpleIconsSamsungpayModule {}
